export interface ClaimedFieldUpdate<T> {
  fieldName: string;
  value: T;
  previousValue?: T;
}

export function claimFieldUpdates<T>(
  pendingValues: Record<string, T>,
  previousValues: Record<string, T>
): ClaimedFieldUpdate<T>[] {
  return Object.entries(pendingValues).map(([fieldName, value]) => ({
    fieldName,
    value,
    previousValue: previousValues[fieldName]
  }));
}

export function removeClaimedFieldValues<T>(
  pendingValues: Record<string, T>,
  claimedUpdates: ClaimedFieldUpdate<T>[]
): Record<string, T> {
  const next = { ...pendingValues };
  for (const { fieldName, value } of claimedUpdates) {
    // Preserve a newer keystroke that arrived after this snapshot was claimed.
    if (Object.is(pendingValues[fieldName], value)) delete next[fieldName];
  }
  return next;
}

export class SerializedTaskQueue {
  private tail: Promise<void> = Promise.resolve();

  enqueue(task: () => Promise<void>): Promise<void> {
    const next = this.tail.catch(() => undefined).then(task);
    this.tail = next;
    return next;
  }
}
